const state = {
    produceInformationFields: [
        {
            key: "process",
            label: "製程",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "pre_total_weight",
            label: "生產前總重(KG)",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "total_weight",
            label: "生產總重(KG)",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key:"attrition_rate_act",
            label:"實際",
            sortable:false,
            class:"font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key:"attrition_rate_standard",
            label:"標準",
            sortable:false,
            class:"font-family-dfyuanstd-w5 table-col-hight"
        }
    ],
    produceInformationItem: [
        // {
        //     "item_title": "實際",
        //     "qty": { name: "計數器支數", count: 130190 },
        //     "unit_weight": "4.65",
        //     "standard_total_weight": "-",
        //     "unit_material_weight": "-",
        //     "material_total_weight": "-",
        // },
        // {
        //     "item_title": "標準",
        //     "qty": { name: "派工支數", count: 361600 },
        //     "unit_weight": "4.65",
        //     "standard_total_weight": "1681.44",
        //     "unit_material_weight": "4.7",
        //     "material_total_weight": "1699.52",
        // }
    ],
}
const getters = {
    get_produceInformationFields: state => {
        return state.produceInformationFields
    },
    get_produceInformationItem: state => {
        return state.produceInformationItem
    },
}
const actions = {
    set_produceInformationFields(context, array) {
        context.commit('SET_PRODUCEINFORMATIONFIELDS', array);
    },
    set_produceInformationItem(context, array) {
        context.commit('SET_PRODUCEINFORMATIONITEM', array);
    },
}
const mutations = {
    SET_PRODUCEINFORMATIONFIELDS(state, array) {
        state.produceInformationItem = array;
    },
    SET_PRODUCEINFORMATIONITEM(state, array) {
        state.produceInformationItem = array;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/produceInformation.js